import { render, staticRenderFns } from "./ColumnTask.vue?vue&type=template&id=7bb72e80"
import script from "./ColumnTask.vue?vue&type=script&lang=js"
export * from "./ColumnTask.vue?vue&type=script&lang=js"
import style0 from "./ColumnTask.vue?vue&type=style&index=0&id=7bb72e80&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports